import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../auth/AuthContext';

export default function SignupPage() {
  const [params] = useSearchParams();
  const token = params.get('token');
  const { signup } = useAuth();
  const nav = useNavigate();

  const [valid, setValid] = useState(null);  // null = lädt, true/false = geprüft
  const [prefillEmail, setPrefillEmail] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [displayName, setDisplayName] = useState('');
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!token) {
      setValid(false);
      return;
    }
    axios
      .get(`/api/invites/check/${token}`)
      .then((r) => {
        setValid(r.data.valid);
        if (r.data.email) {
          setPrefillEmail(r.data.email);
          setEmail(r.data.email);
        }
      })
      .catch(() => setValid(false));
  }, [token]);

  if (valid === null) return <div className="auth-page"><p>Lade Einladung …</p></div>;
  if (!valid) {
    return (
      <div className="auth-page">
        <p>Einladung ungültig oder abgelaufen.</p>
      </div>
    );
  }

  const submit = async (e) => {
    e.preventDefault();
    setError(null);
    setLoading(true);
    try {
      await signup({
        invite_token: token,
        email,
        password,
        display_name: displayName,
      });
      nav('/');
    } catch (err) {
      setError(err.response?.data?.error || 'Registrierung fehlgeschlagen');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <form onSubmit={submit}>
        <h1>Konto anlegen</h1>
        {error && <div className="error">{error}</div>}
        <input
          type="email"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          readOnly={!!prefillEmail}
        />
        <input
          type="text"
          placeholder="Anzeigename"
          value={displayName}
          onChange={(e) => setDisplayName(e.target.value)}
          required
          autoFocus={!prefillEmail}
        />
        <input
          type="password"
          placeholder="Passwort (mind. 8 Zeichen)"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
          minLength={8}
        />
        <button type="submit" disabled={loading}>
          {loading ? '…' : 'Konto anlegen'}
        </button>
      </form>
    </div>
  );
}
